import { useContext } from "react";
import {
  AmeaInfrastructureContext,
  AmeaRoutesDataContext,
  EnvironmentalDataContext,
  MeteoInfoDataContext,
  WeatherDataContext,
  IndexesDataContext,
  AllSensorsDataContext,
  AmeaInfrastructureFiltersContext,
  SensorTypesDataContext,
  NewRouteContext,
  UserAuthContext,
  AmeaDataContext,
  AmeaRoutesCategoriesContext,
} from "./context";

export const useAllContexts = () => {
  const ameaInfrastructures = useContext(AmeaInfrastructureContext);
  const ameaRoutes = useContext(AmeaRoutesDataContext);
  const ameaFilters = useContext(AmeaInfrastructureFiltersContext);
  const ameaData = useContext(AmeaDataContext);
  const environment = useContext(EnvironmentalDataContext);
  const meteo = useContext(MeteoInfoDataContext);
  const weather = useContext(WeatherDataContext);
  const indexes = useContext(IndexesDataContext);
  const allSensors = useContext(AllSensorsDataContext);
  const sensorTypes = useContext(SensorTypesDataContext);
  const newRouteData = useContext(NewRouteContext);
  const auth = useContext(UserAuthContext);
  const ameaRoutesCategories = useContext(AmeaRoutesCategoriesContext);

  return {
    ameaInfrastructures,
    ameaRoutes,
    ameaFilters,
    ameaData,
    environment,
    meteo,
    weather,
    indexes,
    allSensors,
    sensorTypes,
    newRouteData,
    auth,
    ameaRoutesCategories,
  };
};
